import React from 'react';
import PropTypes from 'prop-types';

class HoverObserver extends React.Component {
  state = { hovered: false };

  handleOnPointerOver = () => {
    this.setState({ hovered: true });
  };

  handleOnPointerOut = () => {
    this.setState({ hovered: false });
  };

  render() {
    return (
      <div
        className={this.props.className}
        onPointerOver={this.handleOnPointerOver}
        onPointerOut={this.handleOnPointerOut}
      >
        {this.props.children({ hovered: this.state.hovered })}
      </div>
    );
  }
}

HoverObserver.propTypes = {
  children: PropTypes.func,
  className: PropTypes.string,
};

export default HoverObserver;
